// Склейка результатов Web Speech API в один текст. Вынесена из
// use-voice-input.ts, потому что поведение движков различается и её нужно
// проверять тестами без браузера.
//
// Desktop Chrome: results — список сессии, каждый onresult приносит
// resultIndex и новые/обновлённые элементы, финальные не повторяются.
// Android Chrome/Яндекс (continuous=true): resultIndex всегда 0, а финальные
// фразы приходят повторно — либо той же строкой ещё раз, либо «нарастающей»
// строкой, где новая фраза уже содержит предыдущие. Если просто дописывать
// каждый финальный кусок, в поле получается «Merhaba Merhaba Merhaba bugün…».
// Поэтому текст каждый раз собирается заново из всего списка (идемпотентно),
// а повторы и нарастающие строки схлопываются.

export type TranscriptResult = { isFinal: boolean; transcript: string }

export type MergedTranscript = { final: string; interim: string }

function norm(s: string) {
  return s.replace(/\s+/g, ' ').trim()
}

// Дописать кусок к накопленному тексту с защитой от повторов движка.
function append(acc: string, piece: string): string {
  const p = norm(piece)
  if (!p) return acc
  if (!acc) return p
  const a = acc.toLocaleLowerCase()
  const b = p.toLocaleLowerCase()
  // Нарастающая строка: новый кусок уже содержит всё накопленное.
  if (b.startsWith(a)) return p
  // Чистый повтор последней фразы (или её хвоста).
  if (a === b || a.endsWith(` ${b}`)) return acc
  return `${acc} ${p}`
}

export function mergeTranscript(results: ArrayLike<TranscriptResult>): MergedTranscript {
  let final = ''
  let interim = ''
  for (let i = 0; i < results.length; i++) {
    const r = results[i]
    if (r.isFinal) final = append(final, r.transcript)
    else interim = append(interim, r.transcript)
  }
  // Сырой хвост, который движок уже выдал и финальной строкой, — не показываем
  // дважды.
  if (interim && final.toLocaleLowerCase().endsWith(interim.toLocaleLowerCase())) interim = ''
  return { final, interim }
}
